import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Grid24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M12.85 4C12.85 3.58579 13.1858 3.25 13.6 3.25H20C20.4142 3.25 20.75 3.58579 20.75 4V10.4C20.75 10.8142 20.4142 11.15 20 11.15H13.6C13.1858 11.15 12.85 10.8142 12.85 10.4V4ZM14.35 4.75V9.65H19.25V4.75H14.35ZM4 12.85C3.58579 12.85 3.25 13.1858 3.25 13.6V20C3.25 20.4142 3.58579 20.75 4 20.75H10.4C10.8142 20.75 11.15 20.4142 11.15 20V13.6C11.15 13.1858 10.8142 12.85 10.4 12.85H4ZM4.75 19.25V14.35H9.65V19.25H4.75ZM13.6 12.85C13.1858 12.85 12.85 13.1858 12.85 13.6V20C12.85 20.4142 13.1858 20.75 13.6 20.75H20C20.4142 20.75 20.75 20.4142 20.75 20V13.6C20.75 13.1858 20.4142 12.85 20 12.85H13.6ZM14.35 19.25V14.35H19.25V19.25H14.35ZM4 3.25C3.58579 3.25 3.25 3.58579 3.25 4V10.4C3.25 10.8142 3.58579 11.15 4 11.15H10.4C10.8142 11.15 11.15 10.8142 11.15 10.4V4C11.15 3.58579 10.8142 3.25 10.4 3.25H4ZM4.75 9.65V4.75H9.65V9.65H4.75Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
